import React from "react";
import { Helmet } from "react-helmet";

const OnlineReturnPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Online Return Policy - eYantra</title>
      </Helmet>
      <div class="container my-5">
        <h1 class="text-center texteYantra">Return Policy</h1>
        <p class="text-center">
          Please read our return policy carefully for information on product
          returns, exchanges, replacements, and refunds.
        </p>

        <h2>Return Eligibility</h2>
        <p>
          A return is a process where sellers offer a replacement, an exchange,
          and/or a refund on the product or service provided. There may be
          exceptions based on the product, which comply with the general return
          policy.
        </p>
        <p>
          To ensure eligibility for return, please record a video while
          unpacking/unboxing the product to provide proof of any damage. The
          product must be in its original packaging, unused, and in a similar
          condition as when received.
        </p>
        <p>
          Keep your proof of purchase or receipt safe, as it is required to
          complete the return process.
        </p>

        <h2>Refunds (If Applicable)</h2>
        <p>
          Once your item is received, you will receive a notification email.
          After inspecting the product, we will notify you about the status of
          your return request (whether it is approved or denied).
        </p>
        <p>
          If your return request is approved, the refund will be processed and
          automatically credited to your original payment method. Please allow
          10-12 working days for the refund to reflect in your account.
        </p>

        <h2>Late or Missing Refunds</h2>
        <p>
          If you haven’t received your refund after 10-12 working days, please
          check with your credit card company or bank for the updated status of
          the refund. This will help in case of any delay in the process.
        </p>
        <p>
          If you have already done this and still haven’t received your refund,
          please contact us at{" "}
          <a className="texteYantra text-decoration-none" href="mailto:info@eyantra.com">info@eyantra.com</a> for further
          assistance.
        </p>
      </div>
    </>
  );
};

export default OnlineReturnPolicy;
